import { Component } from '@angular/core';

@Component({
    templateUrl: './not-found.view.html',
    styleUrls: ['./not-found.style.scss'],
})
export class NotFoundView {}
